module.exports = __webpack_public_path__ + "media/images/pic/teachers/wiktoria-piontek-880d989889ec1bcfc0b91c7f8b661729.png";